export default __webpack_public_path__ + "static/thumb-landscape-28e08913e255db48c88281a6e27463ae.jpg";